import { Component, OnInit } from '@angular/core';
import { PackSizeDetails } from '../../../Models/AdminRights/crop-details';
import { AdminRightsService } from '../../../Services/AdminRights/admin-rights.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-pack-size-config',
  templateUrl: './pack-size-config.component.html',
  styleUrls: ['./pack-size-config.component.css']
})
export class PackSizeConfigComponent implements OnInit {
  loader = 'none';
  roleId: string;
  userId: string;
  packSizeDetails: any[] = [];
  savePackSizeDetails: any[] = [];
  packSizeDetailsUpdate: PackSizeDetails[] = [];
  updateDetails: PackSizeDetails = new PackSizeDetails();
  constructor(private adminConfiguration: AdminRightsService, private toastr: ToastrService) {
    this.userId = localStorage.getItem('dsu_userId');
    this.roleId = localStorage.getItem('dsu_roleCode');
  }

  ngOnInit() {
    this.getPackSizeDetails();
  }
  getPackSizeDetails() {
    this.loader = 'block';
    this.adminConfiguration.getPackSizeDetails(this.userId, this.roleId)
      .subscribe((packsizedata) => {
        this.packSizeDetails = packsizedata.data;
        this.loader = 'none';
      });

  }
  updatePackSizeDetails(updateDetails) {
    this.loader = 'block';
    this.savePackSizeDetails = [];
    this.packSizeDetailsUpdate = [];
    for (var i = 0; i < updateDetails.length; i++) {
      this.savePackSizeDetails.push(updateDetails[i].packSizeConfigurationModels)

    }
    for (var j = 0; j < this.savePackSizeDetails.length; j++) {
      for (var k = 0; k < this.savePackSizeDetails[j].length; k++) {
        this.packSizeDetailsUpdate.push(this.savePackSizeDetails[j][k])

      }
    }
    this.adminConfiguration.updatePackSizeDetails(this.packSizeDetailsUpdate, this.userId, this.roleId)
      .subscribe(res => {
        this.toastr.success('Data Saved Successfully.');
        this.loader = 'none';
      });

  }
  cancelStatus() {
    this.getPackSizeDetails();

  }

}
